import React from 'preact/compat';
import PropTypes from 'prop-types';

import { SimpleListItem } from 'rmwc/List';

const ListItem = ({ text, secondaryText, ...props }) => (
  <SimpleListItem
    text={text}
    secondaryText={secondaryText}
    {...props}
  />
);

ListItem.propTypes = {
  text: PropTypes.node,
  secondaryText: PropTypes.node,
};

ListItem.defaultProps = {
  text: undefined,
  secondaryText: undefined,
};

export default ListItem;
